export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./banners-draggable.vue?vue&type=template&id=c0436486"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/banners-draggable.vue?vue&type=template&id=c0436486
// module id = Qda6
// module chunks = 0